module.exports = __webpack_public_path__ + "static/img/005.d2000b07.png";